import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useAppStore } from "@/store/appContext";

const ShareIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
);

const HelpIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

const TrashIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <line x1="10" y1="11" x2="10" y2="17" />
    <line x1="14" y1="11" x2="14" y2="17" />
  </svg>
);

const Header: React.FC = () => {
  const {
    openHowItWorksModal,
    clearCart,
    clearLocalCart,
    refreshProducts,
    selectedProperty,
    selectedKiosk,
  } = useAppStore();

  const [toast, setToast] = useState<string | null>(null);

  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(() => setToast(null), 2500);
    return () => clearTimeout(timer);
  }, [toast]);

  const handleStartOver = () => {
    clearCart();
    clearLocalCart();
  };

  const handleLogoClick = () => {
    refreshProducts();
  };

  const handleShare = async () => {
    if (!selectedProperty || !selectedKiosk) return;
    const url = `${window.location.origin}${window.location.pathname}?property=${selectedProperty.id}&kiosk=${selectedKiosk.id}`;
    try {
      await navigator.clipboard.writeText(url);
      setToast("Link copied to clipboard!");
    } catch {
      setToast("Failed to copy link");
    }
  };

  return (
    <header className="header">
      <div className="header-content">
        <div
          className="logo"
          onClick={handleLogoClick}
          style={{ cursor: "pointer" }}
        >
          <img src="./instamandi-logo.png" alt="Instamandi" />
        </div>
        <div className="header-actions">
          <button
            type="button"
            className="icon-btn"
            onClick={openHowItWorksModal}
            title="How it works"
            aria-label="How it works"
          >
            <HelpIcon />
          </button>
          <button
            type="button"
            className="start-over-btn icon-btn"
            onClick={handleStartOver}
            title="Clear cart"
            aria-label="Clear cart"
          >
            <TrashIcon />
          </button>
          {selectedProperty && selectedKiosk && (
            <button
              type="button"
              className="icon-btn"
              onClick={handleShare}
              title="Copy share link"
              aria-label="Copy share link"
            >
              <ShareIcon />
            </button>
          )}
        </div>
      </div>
      {toast &&
        createPortal(
          <div className="toast" role="status">
            {toast}
          </div>,
          document.body
        )}
    </header>
  );
};

export default Header;
